export default __webpack_public_path__ + "static/media/definicion.bd0b9e32.png";